import * as React from 'react';
import { useSelector } from 'react-redux';
import { useInView } from '@cian/valuation-utils-component';
import { CountryBuildingsBanners } from '../../components/CountryBuildingsBanners';
import { useTracking } from './hooks';
import { selectIsCountryBuildingsBannersAvailable } from '../../selectors/selectIsCountryBuildingsBannersAvailable';

export const CountryBuildingsBannersContainer = () => {
  const [loaded, setLoaded] = React.useState(false);

  const availableInCurrentRegion = useSelector(selectIsCountryBuildingsBannersAvailable);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const { trackClick } = useTracking(inView && loaded);

  const onLoad = React.useCallback(() => {
    setLoaded(true);
  }, [setLoaded]);

  if (!availableInCurrentRegion) {
    return null;
  }

  return (
    <div ref={ref}>
      <CountryBuildingsBanners visible={loaded} onLoad={onLoad} onBannerClick={trackClick} />
    </div>
  );
};
